import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SingleSelectComponent } from '@examdojo/core/select';
import { SOURCE_STATUS_LIST, SOURCE_STATUS_TO_LABEL, SourceStatus } from '../source.model';

@Component({
  selector: 'dojo-source-status-selector',
  template: `
    <dojo-single-select
      [size]="'s'"
      [formCtrl]="formCtrl()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [options]="options"
      [label]="label()"
    />
  `,
  imports: [SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SourceStatusSelectorComponent {
  readonly formCtrl = input.required<FormControl<SourceStatus>>();
  readonly label = input<string>();

  readonly options = SOURCE_STATUS_LIST.map((status) => ({
    value: status,
    label: SOURCE_STATUS_TO_LABEL[status],
  }));
}
